import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Menu,
  NumberInput,
  ScrollArea,
  Select,
  Table,
  TextInput,
  Text,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconArrowLeft, IconCheck, IconPlus } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  TblInventoryCycleCount,
  TblInventoryCycleCountDetailCommand,
} from "../../../../model/TblInventoryCycleCount";
import { DatePickerInput } from "@mantine/dates";
import ModalICCP from "./ModalICCP";
import { getTblDmEmployeeSelect } from "../../../../service/getSelectApi";
import { TblInventorySerialOnHand } from "../../../../model/TblInventorySerialOnHand";
import cx from "clsx";
import classes from "../../../../Styles/TableScrollArea.module.css";
import React from "react";
import { anyAsciiCode } from "../../../../_base/helper/AnyAscii";

const EditDataView = ({ id, onClose, handleEdit }: EditDataViewProps) => {
  const [ICCP, setICCP] = useState<string | null>("");
  const [serial, setSerial] = useState<string>("");
  const [listSerialEdit, setListSerialEdit] = useState<any[]>([]);
  const [dataSerialOnHand, setDataSerialOnHand] = useState<
    TblInventorySerialOnHand[]
  >([]);
  const [
    tblInventoryCycleCountDetailCommands,
    setTblInventoryCycleCountDetailCommands,
  ] = useState<TblInventoryCycleCountDetailCommand[]>([]);
  const [listSerialResponse, setListSerialResponse] = useState<any[]>([]);
  console.log(listSerialEdit);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    []
  );
  const [isEditQuantity, setIsEditQuantity] = useState(false);
  const [visible, { close, open }] = useDisclosure(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [scrolled1, setScrolled1] = useState(false);
  // const [scrolled2, setScrolled2] = useState(false);
  const [enable, setEnable] = useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const scrollAreaRef1 = useRef<HTMLDivElement | null>(null);

  const entity = {
    id: "0",
    code: null,
    cycleCountPeriodId: null,
    cycleCountDate: null,
    employeeId: null,
    isCustomerInv: null,
    status: null,
    autoDetectSubInvOrg: null,
    note: null,
    subInvCode: null,
    tblInventoryCycleCountDetailCommands: null,
  };

  const form = useForm<TblInventoryCycleCount>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    transformValues: (values) => ({
      ...values,
      employeeId: Number(values.employeeId),
      cycleCountPeriodId: Number(values.cycleCountPeriodId),
    }),

    validate: {
      employeeId: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập người kiểm kê !";
        }
      },
      cycleCountPeriodId: (value: number | string | null) => {
        if (!value) {
          return "Vui lòng nhập đợt kiểm kê !";
        }
      },
      note: (value: string | null) => {
        if (value) {
          return hasLength(
            { max: 500 },
            "Ghi chú không được dài hơn 500 ký tự !"
          )(value as string);
        }
      },
    },
  });

  const handleEditTblInventoryCycleCount = async (
    dataSubmit: TblInventoryCycleCount
  ) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblInventoryCycleCount>
    >("/api/v1/TblInventoryCycleCount/update", dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      NotificationExtension.Success("Cập nhật thành công!!!");
      handleEdit();
    }

    close();
  };

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<
      MessageResponse<TblInventoryCycleCount>
    >(`/api/v1/TblInventoryCycleCount/update?id=${id}`);
    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }
    if (callapi) {
      const dataApi = callapi?.data;
      console.log(dataApi);
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
        Promise.all([fetchDataEmployee()]);
        setICCP(dataApi.cycleCountPeriodId?.toString() ?? "");
        if (dataApi.tblInventoryCycleCountDetailCommands) {
          const serialCodes = dataApi.tblInventoryCycleCountDetailCommands.map(
            (detail) => detail.serialCode
          );
          setListSerialEdit(serialCodes);
          setListSerialResponse(dataApi.tblInventoryCycleCountDetailCommands);
        }
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  const fetchDataSerialOnHand = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    let url = `?serial=${serial}`;

    try {
      const response = await repositoryPos.get<
        MessageResponse<TblInventorySerialOnHand[] | TblInventorySerialOnHand>
      >(`api/v1/TblInventorySerialOnHand/detail-for-cycle-count${url}`);

      if (response && response.success) {
        const responseData = response.data as
          | TblInventorySerialOnHand[]
          | TblInventorySerialOnHand;

        if (Array.isArray(responseData)) {
          setDataSerialOnHand((prevData) => [...prevData, ...responseData]);
        } else if (responseData) {
          console.log(responseData);
          setDataSerialOnHand((prevData) => [
            ...prevData,
            { ...responseData, quantity: 1 },
          ]);
        }
      } else {
        setDataSerialOnHand((prevData) => [...prevData]);
      }
    } catch (error) {
      setDataSerialOnHand([]);
      setIsError(true);
      console.error(error);
      return;
    }

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const fetchSerialDataForList = async () => {
    open();
    try {
      const promises = listSerialEdit.map(async (serialCode, index) => {
        const response = await repositoryPos.get<
          MessageResponse<TblInventorySerialOnHand[] | TblInventorySerialOnHand>
        >(
          `api/v1/TblInventorySerialOnHand/detail-for-cycle-count?serial=${serialCode}`
        );

        if (response && response.success) {
          console.log(response);
          const responseData = response.data as
            | TblInventorySerialOnHand[]
            | TblInventorySerialOnHand;

          if (Array.isArray(responseData)) {
            return responseData;
          } else if (responseData) {
            return [
              {
                ...responseData,
                quantity: listSerialResponse[index].quantity,
                idDetailCommand: listSerialResponse[index].id,
              },
            ];
          }
        }
        return [];
      });
      const allData = await Promise.all(promises);
      const mergedData = allData.flat();
      setDataSerialOnHand(mergedData);
    } catch (error) {
      console.error("Error fetching serial data:", error);
      setIsError(true);
    } finally {
      close();
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchDataEmployee = async () => {
    const get = await getTblDmEmployeeSelect();
    setDataEmployeeSelect(
      get
        .filter((item) => item.value != null && item.text != null)
        .map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  const handleAddProduct = () => {
    if (listSerialEdit.length === 0) {
      setListSerialEdit((prev) => [...prev, serial]);
      fetchDataSerialOnHand();
      setSerial("");
    } else if (listSerialEdit.length > 0) {
      if (listSerialEdit.includes(serial)) {
        NotificationExtension.Fails("Mã Code đã được quét !");
      } else {
        setListSerialEdit((prev) => [...prev, serial]);
        fetchDataSerialOnHand();
        setSerial("");
      }
    }
  };

  const handleDeleteProduct = (index: number) => {
    setDataSerialOnHand((prevData) => prevData.filter((_, i) => i !== index));
  };

  const handleQuantityChange = (value: number, index: number) => {
    setDataSerialOnHand((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, quantity: value } : item
      )
    );
  };

  const groupedData = dataSerialOnHand.reduce((acc, item) => {
    if (!acc[item.invCode ?? ""]) {
      acc[item.invCode ?? ""] = [];
    }
    acc[item.invCode ?? ""].push(item);
    return acc;
  }, {} as { [key: string]: TblInventorySerialOnHand[] });

  const rows = Object.entries(groupedData).flatMap(
    ([invCode, items], index) => {
      return items.map((item, itemIndex) => ({
        ...item,
        isFirstInGroup: itemIndex === 0,
        rowSpan: items.length,
      }));
    }
  );

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  useEffect(() => {
    if (listSerialEdit.length > 0) {
      fetchSerialDataForList();
    }
  }, [listSerialEdit]);

  useEffect(() => {
    form.setValues((prev) => ({
      ...prev,
      tblInventoryCycleCountDetailCommands:
        tblInventoryCycleCountDetailCommands,
    }));
    form.setValues((prev) => ({
      ...prev,
      cycleCountPeriodId: ICCP,
    }));
  }, [tblInventoryCycleCountDetailCommands, ICCP]);

  useEffect(() => {
    const updateCycleCountDetails = () => {
      const updatedDetails = dataSerialOnHand.map((item) => ({
        id: item.idDetailCommand?.toString() ?? "",
        serialCode: item.serialCode,
        serialStatus: item.serialStatus,
        quantity: item.quantity,
        note: item.note,
      }));

      setTblInventoryCycleCountDetailCommands(updatedDetails);
    };

    updateCycleCountDetails();
  }, [dataSerialOnHand]);

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        containerRef.current.style.height = `${window.innerHeight - 180}px`;
      }
      if (scrollAreaRef1.current) {
        const height = window.innerHeight - 480;
        scrollAreaRef1.current.style.height = `${height}px`;
      }
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <Box
        component="form"
        mt={10}
        onSubmit={form.onSubmit((e: TblInventoryCycleCount) => {
          handleEditTblInventoryCycleCount(e);
        })}
        onMouseDown={() => setIsEditQuantity(false)}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group
          justify="end"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="red"
            loading={visible}
            onClick={handleEdit}
            leftSection={!visible ? <IconArrowLeft size={18} /> : undefined}
          >
            Quay lại
          </Button>
          <Button
            type="submit"
            color="teal"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Xác nhận
          </Button>
        </Group>
        <Fieldset legend="Thông tin phiếu kiểm kê">
          <Grid>
            <Grid.Col span={{ base: 12, md: 3, lg: 1.75 }}>
              <TextInput
                label="Số phiếu"
                placeholder="Nhập số phiếu"
                size="xs"
                {...form.getInputProps("code")}
                variant="filled"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3, lg: 1.75 }}>
              <DatePickerInput
                label="Ngày kiểm kê"
                valueFormat="DD/MM/YYYY"
                size="xs"
                minDate={new Date()}
                value={
                  form.values.cycleCountDate
                    ? new Date(form.values.cycleCountDate)
                    : undefined
                }
                onChange={(value) => {
                  form.setValues((prev) => ({
                    ...prev,
                    cycleCountDate: value?.toDateString(),
                  }));
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3, lg: 1.75 }}>
              <Select
                label="Người kiểm"
                placeholder="Nhập tên người kiểm"
                data={dataEmployeeSelect}
                value={form.values.employeeId?.toString()}
                onChange={(value) =>
                  form.setValues((prev) => ({
                    ...prev,
                    employeeId: Number(value),
                  }))
                }
                searchable
                clearable
                size="xs"
                withAsterisk
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3, lg: 1.75 }}>
              <Menu
                trigger="hover"
                openDelay={100}
                closeDelay={400}
                width={550}
              >
                <Menu.Target>
                  <TextInput
                    label="Đợt kiểm kê"
                    placeholder="Nhập đợt kiểm kê"
                    value={ICCP ?? ""}
                    onChange={(e) => {
                      setICCP(e.target.value);
                    }}
                    size="xs"
                    withAsterisk
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ModalICCP setICCP={setICCP} ICCP={ICCP} />
                </Menu.Dropdown>
              </Menu>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3, lg: 3.5 }}>
              <TextInput
                label="Diễn giải"
                placeholder="Nhập diễn giải"
                size="xs"
                value={form.values.note ?? ""}
                onChange={(e) =>
                  form.setValues((prev) => ({
                    ...prev,
                    note: e.currentTarget.value,
                  }))
                }
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3, lg: 1.5 }}>
              <Checkbox
                label="Kho khách"
                checked={form.values.isCustomerInv}
                {...form.getInputProps("isCustomerInv")}
                size="xs"
                mt={27.5}
              />
            </Grid.Col>
          </Grid>
        </Fieldset>
        <Fieldset legend="Mã vạch" mt={5}>
          <Flex align="center" gap={"md"}>
            <TextInput
              placeholder="Nhập mã vạch"
              size="xs"
              w={"87.5%"}
              value={anyAsciiCode(serial)}
              onChange={(e) => setSerial(e.currentTarget.value)}
            />
            <Button
              leftSection={<IconPlus size={14} />}
              size="xs"
              w={"11%"}
              onClick={handleAddProduct}
              disabled={serial?.length < 10}
            >
              Thêm hàng
            </Button>
          </Flex>
          <Checkbox
            mt={8}
            label="Tự động nhận diện kho kiểm kê (Bỏ chọn khi cần kiểm kê thừa serial)"
            size="xs"
            checked={form.values.autoDetectSubInvOrg}
            {...form.getInputProps("autoDetectSubInvOrg")}
          />
        </Fieldset>
        <Fieldset legend="Danh sách mã vạch trong kho" mt={5}>
          <ScrollArea
            ref={scrollAreaRef1}
            onScrollPositionChange={({ y }) => setScrolled1(y !== 0)}
          >
            <Table striped highlightOnHover withTableBorder withColumnBorders>
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled1]: scrolled1,
                })}
              >
                <Table.Tr>
                  <Table.Th>Mã vạch</Table.Th>
                  <Table.Th>Mã kho</Table.Th>
                  <Table.Th>Mã sản phẩm</Table.Th>
                  <Table.Th>Tên sản phẩm</Table.Th>
                  <Table.Th>Số lượng kiểm kê</Table.Th>
                  <Table.Th>Trạng thái serial</Table.Th>
                  <Table.Th>Ghi chú</Table.Th>
                  <Table.Th>Thao tác</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {Array.isArray(rows) &&
                  rows?.map((item, index) => (
                    <Table.Tr key={index}>
                      <Table.Th>{item.serialCode}</Table.Th>
                      {item.isFirstInGroup ? (
                        <Table.Th rowSpan={item.rowSpan}>
                          {item.invCode}
                        </Table.Th>
                      ) : (
                        <></>
                      )}
                      <Table.Th>{item.serialCode}</Table.Th>
                      <Table.Th>{item.itemName}</Table.Th>
                      <Table.Th
                        onDoubleClick={() => {
                          setIsEditQuantity(true);
                          setEditIndex(index);
                        }}
                        onMouseDown={(event: React.MouseEvent) =>
                          event.stopPropagation()
                        }
                      >
                        {editIndex === index && isEditQuantity ? (
                          <NumberInput
                            value={item.quantity ?? 1}
                            onChange={(value: string | number) =>
                              handleQuantityChange(Number(value) ?? 1, index)
                            }
                            size="xs"
                            w={95}
                            hideControls
                          />
                        ) : (
                          <Text fw={700} size="13px">
                            {item.quantity}
                          </Text>
                        )}
                      </Table.Th>
                      <Table.Th>{item.serialStatus}</Table.Th>
                      <Table.Th>{item.note}</Table.Th>
                      <Table.Th>
                        <Button
                          size="xs"
                          variant="filled"
                          color="red"
                          onClick={() => handleDeleteProduct(index)}
                        >
                          Xoá
                        </Button>
                      </Table.Th>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>
          </ScrollArea>
        </Fieldset>
        {/* <Fieldset legend="Danh sách mã vạch không tìm thấy" mt={5}>
          <ScrollArea
            h={85}
            onScrollPositionChange={({ y }) => setScrolled2(y !== 0)}
          >
            <Table striped highlightOnHover withTableBorder withColumnBorders>
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled2]: scrolled2,
                })}
              >
                <Table.Tr>
                  <Table.Th>Mã vạch</Table.Th>
                  <Table.Th>Mã kho</Table.Th>
                  <Table.Th>Mã sản phẩm</Table.Th>
                  <Table.Th>Tên sản phẩm</Table.Th>
                  <Table.Th>Số lượng kiểm kê</Table.Th>
                  <Table.Th>Trạng thái serial</Table.Th>
                  <Table.Th>Ghi chú</Table.Th>
                  <Table.Th>Thao tác</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody></Table.Tbody>
            </Table>
          </ScrollArea>
        </Fieldset> */}
      </Box>
    </div>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
  handleEdit: any;
};
